<template>
	<div class="row">
		<div class="col-md-12">
			<h3 v-html="formTitle" class="text-center"></h3>
			<div class="form-group">
				<label>Nom : </label>
				<bsInput required type="text" v-model.lazy="name"></bsInput>
				<div style="color:red;" v-if="requiredName">
						Le nom doit être défini.
				</div>
			</div>
			<div class="form-group">
				<label>Genre : </label>
				<vSelect v-model="gender">
					<vOption value="MALE">Homme</vOption>
					<vOption value="FEMALE">Femme</vOption>
				</vSelect>
			</div>
			<div class="form-group">
				<label>Description : </label>
				<bsInput type="textarea" v-model.lazy="description"></bsInput>
			</div>
            <div class="form-group">
                <div v-if="currentPerson.picture">
                    <label>Image actuelle : </label>
                    <img height="100px" width="100px" :src="getRemotePictureUrl()">              
                </div>
                <label>Image du personnage : </label>
                <input type="file" ref="personPicture" name="personPicture" accept="image/*">
            </div>
		</div>
		<div class="col-md-12 text-right">
			<button class="btn btn-info btn-sm" type="button" @click="save">Sauvegarder</button>
		</div>
	</div>
</template>

<script>
    import { input as BsInput, select as VSelect, option as VOption }  from 'vue-strap'

    export default {
        components: {
            BsInput,
            VSelect,
            VOption
        },
        computed: {
            currentPerson: function() {
                return this.$store.state.admin.currentPerson;
            },
            formMode: function() {
				return this.$route.meta.mode;
            },
            formTitle() {
                if (this.formMode != "create")   {
                    return "Edition du personnage «" + this.currentPerson.name + '»';
                }
                return "Nouveau personnage";
            },
            name: {
                get() {
                    return this.currentPerson.name;
                },
                set(value) {
                    this.$store.commit('CURRENT_PERSON_UPDATED', {key: 'name', data: value});
                }
            },
            gender: {
                get() {
                    return this.currentPerson.gender;
                },
                set(value) {
                    this.$store.commit('CURRENT_PERSON_UPDATED', {key: 'gender', data: value});

                }
            },
            description: {
                get() {
                    return this.currentPerson.description;
                },
                set(value) {
                    this.$store.commit('CURRENT_PERSON_UPDATED', {key: 'description', data: value});
                }
            }
        },
        methods: {
            getRemotePictureUrl()  {
                return process.env.API_URL.replace('/app_dev.php', '') + '/' + this.currentPerson.picture + '?ts=' + Date.now();
            },
            save()  {
                if (this.name != "")    {
                    let textPatch = this.formMode == 'create' ? 'créé' : 'mis à jour';
                    let successCallback = (id) => {
                        this.$router.push({ name: 'PersonList', params: { themeId: this.$route.params.themeId }});
                        this.$store.commit('ALERT_DATA_UPDATED', {
                            text: 'Le personnage «' + this.currentPerson.name + '» a été ' + textPatch + ' avec succès.',
                            type: 'success'
                        });
                    };

                    this.$store.dispatch(this.formMode == "create" ? 'createPerson' : 'updatePerson', {
                        themeId: this.$route.params.themeId,
                        newPerson: this.currentPerson,
                        picture: this.$refs.personPicture.files[0],
                        callbacks: { success: successCallback }
                    });
                }
                else    {
                    this.requiredName = true;
                }
            }
        },
        data: function()  {
            return {
                requiredName: false,
                hasNewPicture: false
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux personnages',
                pathData: {
                    name: "PersonList",
                    params: {
                        themeId: this.$route.params.themeId
                    }
                }
            });
        }
    };
</script>
